import { useCallback, useEffect, useState } from 'react';
import {
    getVersionPollIntervalMs,
    isNewVersionAvailable,
    isVersionCheckEnabled
} from '../services/app-version-service';

export function useAppVersionCheck() {
    const [updateAvailable, setUpdateAvailable] = useState(false);

    const checkForUpdate = useCallback(async () => {
        if (!isVersionCheckEnabled()) {
            return;
        }

        try {
            const hasUpdate = await isNewVersionAvailable();
            setUpdateAvailable(hasUpdate);
        } catch {
            // Ignore transient network errors during background checks.
        }
    }, []);

    useEffect(() => {
        if (!isVersionCheckEnabled()) {
            return undefined;
        }

        checkForUpdate();

        const intervalId = window.setInterval(checkForUpdate, getVersionPollIntervalMs());

        const onVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                checkForUpdate();
            }
        };

        const onServiceWorkerUpdate = () => {
            setUpdateAvailable(true);
        };

        document.addEventListener('visibilitychange', onVisibilityChange);
        window.addEventListener('touchsoft-sw-update', onServiceWorkerUpdate);

        return () => {
            window.clearInterval(intervalId);
            document.removeEventListener('visibilitychange', onVisibilityChange);
            window.removeEventListener('touchsoft-sw-update', onServiceWorkerUpdate);
        };
    }, [checkForUpdate]);

    const reloadApp = useCallback(() => {
        window.location.reload();
    }, []);

    return {
        updateAvailable,
        reloadApp
    };
}
